// Подписи ролей — одни на всю систему. Раньше одна и та же роль называлась
// по-разному в меню, профиле и списке сотрудников (аудит интерфейса, стр. 210).
export const ROLE_LABELS = {
  ADMIN: 'Администратор',
  COMPANY_ADMIN: 'Администратор компании',
  WORKER: 'Сотрудник',
};
